export default {
  INSERT_INTO_ALL: "INSERT_INTO_ALL_PAYMENT_GROUP",
  ADD_TO_IN_PROGRESS: "ADD_TO_IN_PROGRESS_PAYMENT_GROUP",
  REMOVE_FROM_IN_PROGRESS: "REMOVE_FROM_IN_PROGRESS_PAYMENT_GROUP",
  INSERT_INTO_FORMS: "INSERT_INTO_FORMS_PAYMENT_GROUP",
  DESTROY_FORM: "DESTROY_FORM_PAYMENT_GROUP",
  SET_FORM_ERROR: "SET_FORM_ERROR_PAYMENT_GROUP",
  UPDATE_FORM_INSTANCE: "UPDATE_FORM_INSTANCE_PAYMENT_GROUP",
  INSERT_INTO_PAGINATION: "INSERT_INTO_PAGINATION_PAYMENT_GROUP",
  INSERT_INTO_FILTERED: "INSERT_INTO_FILTERED_PAYMENT_GROUP",
  RESET_STATE: "RESET_STATE_PAYMENT_GROUP",
  SET_ASK_DELETE_DATA: "SET_ASK_DELETE_DATA_PAYMENT_GROUP",
  REMOVE_OBJECT: "REMOVE_OBJECT_PAYMENT_GROUP",
  CLEAR_FETCHED: "CLEAR_FETCHED_PAYMENT_GROUP",

  LIST_URL: "/brf/loans/paymentgroup/list/",
  POST_URL: "/brf/loans/paymentgroup/",
  PATCH_URL: "/brf/loans/paymentgroup/",
  GET_URL: "/brf/loans/paymentgroup/",

  STORE_NAME: "paymentGroup",
};
